// src/legal/termsModel.js — the terms acceptance, as data (v221). Pure functions, no I/O.
//
// Contract: <BACKEND_FOLDER>/docs/frontend/2026-10-29-tos-deactivation-purge-list-handoff.md § 1 and
// <BACKEND_FOLDER>/docs/api-server/endpoints.md § Legal. One shape everywhere:
//   { tos: { version, url, pdfUrl }, privacy: { version, url, pdfUrl } }
// ⛔ The version is echoed back VERBATIM (`null` included: no version configured) — never trimmed, never parsed.
// ⛔ Links are https only (the BE accepts nothing else when a version is added); anything else → null (plain text).
// ⭐ A 409 TERMS_VERSION_CHANGED carries the new texts in its FLAT body (`current_tos_version`, …): the page takes
//    them from there, never from a re-read (a cached answer could loop the 409).
import { safeHttpsUrl } from '../billing/stripeLink.js';

export const TERMS_CONFLICT_CODE = 'TERMS_VERSION_CHANGED';

function documentFrom(source, prefix) {
  const version = source?.[`${prefix}version`];
  return {
    version: typeof version === 'string' ? version : null,
    url: safeHttpsUrl(source?.[`${prefix}url`]),
    pdfUrl: safeHttpsUrl(source?.[`${prefix}pdf_url`]),
  };
}

/** GET /api/v1/legal/current → the normalized shape. */
export function normalizeTerms(json) {
  return { tos: documentFrom(json, 'tos_'), privacy: documentFrom(json, 'privacy_') };
}

/** Is this the 409 that says the texts changed while the page was open? */
export function isTermsConflict(err) {
  return !!err && err.status === 409 && err.code === TERMS_CONFLICT_CODE;
}

/** The new texts, from the 409 body (buildApiError keeps it in `err.extras`, and hoists it onto `err`). */
export function termsFromConflict(err) {
  const source = err?.extras || err || {};
  return { tos: documentFrom(source, 'current_tos_'), privacy: documentFrom(source, 'current_privacy_') };
}

/** The three fields every accepting request carries: exactly the versions shown. */
export function termsBody(terms) {
  return {
    terms_accepted: true,
    tos_version: terms?.tos?.version ?? null,
    privacy_version: terms?.privacy?.version ?? null,
  };
}
